import React from 'react';
import { Box, Fab, Tooltip, Zoom } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { styled } from '@mui/material/styles';

const StyledFab = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(3),
  right: theme.spacing(3),
  backgroundColor: '#25D366',
  '&:hover': {
    backgroundColor: '#128C7E',
  },
  zIndex: 1000,
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)',
  },
}));

const PulseAnimation = styled('div')({
  position: 'absolute',
  width: '100%',
  height: '100%',
  borderRadius: '50%',
  backgroundColor: '#25D366',
  opacity: 0.7,
  animation: 'pulse 1.5s infinite',
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(1)',
      opacity: 0.7,
    },
    '70%': {
      transform: 'scale(1.3)',
      opacity: 0,
    },
    '100%': {
      transform: 'scale(1.3)',
      opacity: 0,
    },
  },
});

const WhatsAppWidget = ({ phoneNumber }) => {
  // Default to the phone number from the FAQ if not provided
  const whatsappNumber = phoneNumber || '07391137185';
  
  // Format phone number for WhatsApp link (remove spaces, add country code if needed)
  const formattedNumber = whatsappNumber.startsWith('0') 
    ? '44' + whatsappNumber.substring(1).replace(/\s+/g, '') 
    : whatsappNumber.replace(/\s+/g, '');
  
  const handleClick = () => {
    window.open(`https://wa.me/${formattedNumber}`, '_blank');
  };

  return (
    <Tooltip 
      title="Chat with us on WhatsApp"
      placement="left"
      TransitionComponent={Zoom}
    >
      <Box sx={{ position: 'relative' }}>
        <PulseAnimation />
        <StyledFab
          color="primary"
          aria-label="chat on whatsapp"
          onClick={handleClick}
          size="large"
        >
          <WhatsAppIcon fontSize="large" />
        </StyledFab>
      </Box>
    </Tooltip>
  );
};

export default WhatsAppWidget; 